export default "__VITE_ASSET__CRwaTcP7__"